import React, { useEffect } from 'react';
import { connect,useDispatch } from 'react-redux';
import { compose } from 'redux';
import {getDataOnRequest} from '../redux/actions/CommonActions'
import { toast } from 'react-toastify';
const ServiceUserMainCandidateContainer = (OriginalComponent) => {
  const NewComponent = (props) => {
    const dispatch = useDispatch();
    useEffect(()=>{
      toast.dismiss();
      if(props.userAuth.users_access_token && props.serviceUserDetailsCandidate){
        let getPathName = window.location.pathname;
        let getServiceUserId = (getPathName === "/service-user-details" ? localStorage?.getItem('getServiceUserId') : "");
        dispatch(getDataOnRequest((getServiceUserId ? props.userAuth.users_access_token+'/'+getServiceUserId : props.userAuth.users_access_token),'GetServiceUserDetailsForCandidate','SET_SERVICE_USER_CANDIDATE_DETAILS'))
      }     
      
   }, [props.userAuth.users_access_token])

    return (
      <OriginalComponent {...props}  />
    )
  }
  return NewComponent
}

const mapStateToProps = (state) => {
  return {
    userAuth:state.auth.authUserData,
    userInfo:state.userProfile.userData,
    serviceUserDetailsCandidate:state.serviceUserDetailsCandidate.serviceUserDetailsCandidate
  };
};

const composedServiceUserMainCandidateContainer = compose(connect(mapStateToProps), ServiceUserMainCandidateContainer)
export default composedServiceUserMainCandidateContainer;

